// extracted by mini-css-extract-plugin
module.exports = {"step":"step-Fy9cY","text":"text-3iBl_"};